import React, { lazy, Suspense } from 'react';

const LazyApplicationList = lazy(() => import('./ApplicationList'));

const ApplicationList = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyApplicationList {...props} />
  </Suspense>
);

export default ApplicationList;
